<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  created () {
    this.initViewPort()
  },
  mounted () {
  },
  methods: {
    initViewPort () {
      const width = 375
      const scale = window.innerWidth / width
      let meta = document.querySelector('meta[name=viewport]')
      const content = `width=${width}, init-scale=${scale}, user-scalable=no`
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute('name', 'viewport')
        document.head.appendChild(meta)
      }
      meta.setAttribute('content', content)
    }
  }
}
</script>

  <script>
    // var UserAgentUM = navigator.userAgent.toLowerCase();
    // if(UserAgentUM.indexOf('peoplesn')==-1){
        var _czc = _czc || [];
        (function () {
          var um = document.createElement("script");
          um.src = "https://s4.cnzz.com/z.js?id=1281408372&async=1";
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(um, s);
        })();
    // }
  </script>
<style lang="less" scoped>

@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .bottom-button {
    margin-bottom: constant(safe-area-inset-bottom);
    margin-bottom: env(safe-area-inset-bottom)
  }
}
</style>
